import { StreamChat } from 'stream-chat'
import Service from '../lib/service'
import request from '../lib/request'
import config from '../lib/config'

const UNREAD_RELEVANT_EVENTS = [
  'message.new',
  'notification.message_new',
  'notification.mark_read',
  'notification.mark_unread',
  'notification.channel_truncated',
  'notification.channel_deleted',
]

class StreamService extends Service {
  constructor() {
    super()
    this.client = null
    this.userId = null
    this.connected = false
    this.connection_error = false
    this.listenersRegistered = false
  }

  async connect() {
    if (this.connected) return true

    let tokenResponse
    try {
      tokenResponse = await request.post('v3/chat/stream/tokens')
    } catch (err) {
      this.connection_error = true
      return false
    }

    const { stream_user_key, token } = tokenResponse
    this.userId = stream_user_key

    try {
      this.client = StreamChat.getInstance(config.stream.apiKey)
      await this.client.connectUser({ id: this.userId }, token)
      this.connected = true
      this.connection_error = false

      this.registerUnreadListener()
      return true
    } catch (err) {
      console.error('StreamService: failed to connect user', err)
      await this.disconnect()
      throw err
    }
  }

  async disconnect() {
    if (!this.client) return

    await this.client.disconnectUser().catch(err => console.warn(err))
    this.client = null
    this.userId = null
    this.connected = false
    this.listenersRegistered = false
  }

  async getUserStreamChannels() {
    if (this.connection_error) {
      return [] // The user probably has no Stream chat channels, return empty array
    }

    if (!this.isConnected()) {
      await this.connect()
    }

    try {
      const filter = { members: { $in: [this.userId] } }
      const sort = [{ last_message_at: -1 }]

      const channels = await this.client.queryChannels(filter, sort, {
        state: true,
        watch: true,
        presence: true,
      })

      return channels
    } catch (err) {
      console.error('StreamService: failed to get user channels', err)
      return []
    }
  }

  registerUnreadListener() {
    if (!this.client || this.listenersRegistered) return
    this.listenersRegistered = true

    this.unreadHandler = event => {
      if (typeof event.total_unread_count === 'number') {
        this.emit('unread.total', event.total_unread_count)
      }
    }
    UNREAD_RELEVANT_EVENTS.forEach(t => this.client.on(t, this.unreadHandler))
  }

  isConnected() {
    return this.connected && !!this.client
  }
}

const streamService = new StreamService()
export default streamService
